import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, Link } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { label: "About", href: "/#about" },
  { label: "Skills", href: "/#skills" },
  { label: "Projects", href: "/#blog" },
  { label: "CTF Write-ups", href: "/#ctf" }, // Restored
  { label: "Contact", href: "/#contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Detect if we are on a Project/Deep page
  const isDeepPage = location.pathname !== '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href) => {
    const [path, hash] = href.split('#');
    if (location.pathname === '/' && hash) {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <AppBar position="fixed" sx={{ 
      width: "fit-content", 
      bgcolor: "transparent", 
      backdropFilter: scrolled ? "blur(10px)" : "none",
      left: "50%", 
      transform: "translateX(-50%)", 
      top: 20, 
      borderRadius: "999px", 
      boxShadow: scrolled ? 3 : "none",
      transition: "all 0.3s ease" 
    }}>
      <Toolbar sx={{ display: "flex", justifyContent: "center", px: 4 }}>
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
          {isDeepPage ? (
            // NAV UI FOR PROJECT/DEEP PAGES
            <Link
              component="button"
              color="text.primary"
              underline="none"
              onClick={() => navigate('/')}
              sx={{ fontWeight: 'bold', '&:hover': { color: 'primary.main' } }}
            >
              ← Back to Portfolio
            </Link>
          ) : (
            // NAV UI FOR HOMEPAGE
            navItems.map((item) => (
              <Link
                key={item.label}
                component="button"
                color="text.primary"
                underline="none"
                onClick={() => handleNavClick(item.href)}
                sx={{ '&:hover': { color: 'primary.main' } }}
              >
                {item.label}
              </Link>
            ))
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default Header;